/* eslint-disable @typescript-eslint/no-explicit-any */
import { FunctionComponent, ReactElement, useContext, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Contract, Sector } from '../../adapters/api-client/referential/Referential.model';
import { GenderInput, GenderInputDS, SelectedButton } from '../../components/DesignSystem';
import { store } from '../../store/store';
import { updateStore } from '../../store/store.actions';
import { ValidityHtmlElement } from '../../utils/DsType';

const Container = styled.div`
  date-input {
    --width-component: 134px;
  }
  selected-button {
    max-width: 33%;
  }
  .display-component {
    display: ${(props: any) => (props.displayProfession ? 'flex' : 'none')};
  }
`;

const SituationPro: FunctionComponent<Record<string, never>> = (): ReactElement => {
  const {
    state: { holder },
    apiStatus,
    dispatch,
  } = useContext(store);
  //api
  //const { response: sectors } = useFetch(() => apiClient().referential.getSectors());
  //const { response: contracts } = useFetch(() => apiClient().referential.getContracts());
  const sectorsCopy = [
    {
      code: 'PRI',
      label: 'Secteur privé',
      id: '1',
    },
    {
      code: 'PUB',
      label: 'Secteur public',
      id: '2',
    },
    {
      code: 'IPL',
      label: 'Professions libérales',
      id: '3',
    },
    {
      code: 'RET',
      label: 'Retraité(e)',
      id: '4',
    },
    {
      code: 'AUT',
      label: 'Autre',
      id: '5',
    },
  ];
  const contractsCopy = [
    {
      code: '2',
      label: 'CDI',
      id: '1',
    },
    {
      code: '1',
      label: 'CDD / Intérim',
      id: '2',
    },
    {
      code: '0',
      label: 'Autre',
      id: '3',
    },
  ];
  //refs
  const activitySectorCodeRef = useRef<GenderInputDS>(null);
  const employmentContractCodeRef = useRef<GenderInputDS>(null);

  const onSectorChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    if (!!activitySectorCodeRef && activitySectorCodeRef.current !== null) {
      (activitySectorCodeRef.current as unknown as ValidityHtmlElement).assignValidity();
      dispatch(
        updateStore({
          holder: {
            job: {
              activitySectorCode: e.currentTarget?.value,
            },
          },
        }),
      );
    }
  };
  const onContractChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    if (!!employmentContractCodeRef && employmentContractCodeRef.current !== null) {
      (employmentContractCodeRef.current as unknown as ValidityHtmlElement).assignValidity();
      dispatch(
        updateStore({
          holder: {
            job: {
              employmentContractCode: e.currentTarget?.value,
            },
          },
        }),
      );
    }
  };
  useEffect(() => {
    if (!!activitySectorCodeRef && activitySectorCodeRef.current !== null) {
      activitySectorCodeRef.current.value = holder?.job?.activitySectorCode || '';
    }
    if (!!employmentContractCodeRef && employmentContractCodeRef.current !== null) {
      employmentContractCodeRef.current.value = holder?.job?.employmentContractCode || '';
    }
  }, [apiStatus]);
  return (
    <>
      <Container>
        <GenderInput
          ref={activitySectorCodeRef}
          class="to-validate trackable-click"
          label="Secteur d'activité"
          data-id="activitySectorCode"
          onSelectedElementChange={onSectorChange}
          value={holder?.job?.activitySectorCode || ''}
          error-message="Veuillez choisir votre secteur d'activité."
        >
          {sectorsCopy &&
            sectorsCopy.map(({ id, code, label }: Sector) => (
              <SelectedButton id={id} key={code} value={code} secondary>
                {label}
              </SelectedButton>
            ))}
        </GenderInput>
      </Container>
      <Container>
        {(holder?.job?.activitySectorCode === 'PUB' || holder?.job?.activitySectorCode === 'PRI') && (
          <GenderInput
            ref={employmentContractCodeRef}
            class="to-validate trackable-click"
            label="Type de contrat"
            data-id="contractCode"
            onSelectedElementChange={onContractChange}
            value={holder?.job?.employmentContractCode || ''}
            error-message="Veuillez choisir votre contrat."
          >
            {contractsCopy &&
              contractsCopy.map(({ id, code, label }: Contract) => (
                <SelectedButton id={id} key={code} value={code} secondary>
                  {label}
                </SelectedButton>
              ))}
          </GenderInput>
        )}
      </Container>
    </>
  );
};

export default SituationPro;
